import React, { Component } from 'react';
import { Col, FormControl, FormGroup, Grid, Row } from 'react-bootstrap';
import '../Client.css';
import './Login.css';
import { Link, Redirect } from 'react-router-dom';
import queryString from 'query-string';
import accountVerifiedPng from './account-verified.png';
import SimpleErrorList from '../../shared/errors/SimpleErrorList';
import { connect } from 'react-redux';
import { authenticationRequest } from '../../../actions/authentication';
import PropTypes from 'prop-types';

export class Login extends Component {
  static propTypes = {
    loggedIn: PropTypes.bool,
    errors: PropTypes.arrayOf(PropTypes.string),
    onSubmit: PropTypes.func,
  };

  constructor() {
    super();
    this.state = {
      email: '',
      password: '',
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.errors.length > 0) {
      this.setState({
        password: '',
      });
    }
  }

  handleEmailChange = (event) => {
    this.setState({ email: event.target.value });
  };

  handlePasswordChange = (event) => {
    this.setState({ password: event.target.value });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.props.onSubmit(this.state.email, this.state.password);
  };

  render() {
    const params = queryString.parse(this.props.location.search);
    const onboarding = params.onboarding;

    let currentView;
    if (this.props.loggedIn) {
      if (onboarding) {
        currentView = <Redirect to={{ pathname: '/user-invitations' }} />;
      } else {
        let newLocation = '/';
        if (
          this.props.location.state !== undefined &&
          this.props.location.state.hasOwnProperty('referrer')
        ) {
          // If a referrer location is defined un state, go to it
          newLocation = this.props.location.state.referrer;
        }

        currentView = (
          <Redirect
            to={{
              pathname: newLocation,
            }}
          />
        );
      }
    } else {
      currentView = (
        <div className="login client">
          <Grid>
            <Row>
              <Col md={6} mdOffset={3}>
                <div className="title">
                  <span>Log in to your account</span>
                </div>
              </Col>
            </Row>
            {onboarding ? (
              <Row>
                <Col md={6} mdOffset={3}>
                  <div className="subtitle">
                    <img src={accountVerifiedPng} alt="Account verified" />
                    <span>Account Verified</span>
                  </div>
                </Col>
              </Row>
            ) : null}

            <Row>
              <Col md={6} mdOffset={3}>
                <div className="form-container">
                  <form onSubmit={this.handleSubmit}>
                    <Col md={12}>
                      <FormGroup>
                        <FormControl
                          type="email"
                          className="input"
                          value={this.state.email}
                          placeholder="Email"
                          onChange={this.handleEmailChange}
                          required
                        />
                      </FormGroup>
                    </Col>

                    <Col md={12}>
                      <FormGroup>
                        <FormControl
                          type="password"
                          className="input"
                          value={this.state.password}
                          placeholder="Password"
                          onChange={this.handlePasswordChange}
                          required
                        />
                      </FormGroup>
                    </Col>

                    {this.props.errors.length > 0 ? (
                      <Col md={12}>
                        <SimpleErrorList errors={this.props.errors} />
                      </Col>
                    ) : null}

                    <Col md={12}>
                      <FormGroup>
                        <input
                          type="submit"
                          className="btn-select btn-orange"
                          value="Log in"
                        />
                      </FormGroup>
                    </Col>
                  </form>
                </div>
              </Col>
            </Row>

            <Row>
              <Col md={6} mdOffset={3}>
                <div className="bottom-title-wrapper">
                  <div className="bottom-title">
                    <Link to="/recover-password">Forgot your password?</Link>
                    <Link
                      target="_blank"
                      to={{ pathname: process.env.REACT_APP_CLICKUP_FORM_URL }}
                    >
                      Support
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>
      );
    }

    return <div>{currentView}</div>;
  }
}

export default connect(
  (state) => {
    return {
      loggedIn: state.auth.loggedIn,
      errors: state.auth.errors,
    };
  },
  (dispatch) => {
    return {
      onSubmit: (email, password) => {
        dispatch(authenticationRequest(email, password));
      },
    };
  }
)(Login);



// WEBPACK FOOTER //
// ./src/components/client/login/Login.js